// extracted by mini-css-extract-plugin
export default {"userName":"BookingsForTheDay_userName__yrNJ8"};